export function replaceCommas(str: string): string {
  return str.replace(/,/g, '.')
}
